import { render, staticRenderFns } from "./shebei.vue?vue&type=template&id=205e1739&scoped=true&"
import script from "./shebei.vue?vue&type=script&lang=js&"
export * from "./shebei.vue?vue&type=script&lang=js&"
import style0 from "./shebei.vue?vue&type=style&index=0&id=205e1739&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e1739",
  null
  
)

export default component.exports